import React from 'react';
// import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import { Form } from "react-bootstrap";
import slotimg from "../../images/free.png";
import './DeliveryPerson.css';
import RegistrationImage from './Registration.jpg'; // Adjust path as necessary
import Pagination from 'react-js-pagination';
import DefaultProfileImage from './Registration.jpg';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import profile from "../../images/splash/avatar.png";
import Loader from '../Loader/Loader';



const AdminSupplierMaster = () => {
  const history = useHistory();
  
  const [ isCreate,setCreate ] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Number of items per page
  const [searchTerm, setSearchTerm] = useState('');
  const [uploadedDocument, setUploadedDocument] = useState(null);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const [ rejectremark,setRejectRemarks ] = useState('');
  const [dataID, setDataID] = useState('');
  const [ data,setData ] = useState([]);
  const [ selectedPerson, setSelectedPerson ] = useState(null);
  const [activeTab, setActiveTab] = useState("personalInformation");

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedDocument(URL.createObjectURL(file));
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [showrePop, showRemark] = useState(false);
  const [modalData, setModalData] = useState([]);
  

  // Function to open the modal
  const openModal = () => {
    setShowModal(true);
  };

  const openModalEye = (item) => {
    const details = {
      "id": item.id,
      "personalInformation": {
        name: item.name,
        email_id: item.email_id,
        mobile_no: item.mobile_no,
        secondary_mobile: item.secondary_mobile,
        profile_image: item.profile_image,
        dob: item.dob,
        Father_name: item.Father_name,
        current_location: item.current_location,
        blood_group: item.blood_group,
        available_status: item.available_status,
        joined_date: item.joined_date,
        approval_status: item.approval_status,
        reject_remarks: item.reject_remarks,
      },
      "personalDocuments": {
        name: item.name,
        profile_image: item.profile_image,
        id_proof_document: item.id_proof_document,
        aadhar_front: item.aadhar_front,
        aadhar_back: item.aadhar_back,
        driving_license: item.driving_license,
        personal_document_status: item.personal_document_status,
        personal_document_remark: item.personal_document_remark,
      },
      "vehicleDetails": {
        name: item.name,
        profile_image: item.profile_image,
        vehicle_type: item.vehicle_type,
        capacity: item.capacity,
        vehicle_model: item.vehicle_model,
        vehicle_year: item.vehicle_year,
        registration_no: item.registration_no,
        vehicle_doc1: item.vehicle_doc1,
        vehicle_doc2: item.vehicle_doc2,
        vehicle_detail_status: item.vehicle_detail_status,
        vehicle_detail_remark: item.vehicle_detail_remark,
      },
      "bankDetails": {
        name: item.name,
        profile_image: item.profile_image,
        bank_name: item.bank_name,
        account_number: item.account_number,
        bank_detail_status: item.bank_detail_status,
        branch_name: item.branch_name,
        ifsc_code: item.ifsc_code,
        bank_doc1: item.bank_doc1,
        bank_doc2: item.bank_doc2,
        bank_detail_remark: item.bank_detail_remark,
      },
    };

    const enrichedItem = { details };
    setSelectedPerson(enrichedItem);
    setCreate(true);
    setModalData({
      id: item.id,
      name: item.name,
      email_id: item.email_id,
      mobile_no: item.mobile_no,
      current_location: item.current_location,
      vehicle_id: item.vehicle_id,
      vehicle_type: item.vehicle_type,
      capacity: item.capacity,
      vehicle_model: item.vehicle_model,
      vehicle_year: item.vehicle_year,
      registration_no: item.registration_no,
      vehicle_status: item.vehicle_status,
      bank_name: item.bank_name,
      account_number: item.account_number,
      id_proof_document: item.id_proof_document,
      vehicle_doc1: item.vehicle_doc1,
      vehicle_doc2: item.vehicle_doc2,
      bank_doc1: item.bank_doc1,
      bank_doc2: item.bank_doc2,
      joined_date:item.joined_date,
      reject_remarks:item.reject_remarks,
      approval_status:item.approval_status,
      assigned_location:item.assigned_location,
      available_status:item.available_status,
      password:item.password,
      shop_id:item.shop_id,
      assigned_vehicle_id:item.assigned_vehicle_id,
      profile_image:item.profile_image
    });
  };


  const openRemark = (dataId) => {
    showRemark(true);
    setDataID(dataId);
  };
  
  // Function to close the modal
  const closeModal = () => {
    setShowModal(false);
  };

  const [isEditing, setIsEditing] = useState(false);
  const [isEditingVeh, setIsEditingVeh] = useState(false);
  const [isEditingBank, setIsEditingBank] = useState(false);

  useEffect(() => {
    fetchRole();
  }, []);


  const fetchRole = async () => {
    setLoading(true);
    const token = localStorage.getItem('Token');
    const shopId =localStorage.getItem('ShopId');
    try {
       const response = await axios.get(`${var_api}delivery-person-management/get-details/${shopId}`,{
        headers:{
          Authorization:`${token}`
        }
       });
       console.log("response",response)
      const user =response.data;
      setData(user);
      
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
      setData([])
    }
    finally{
      setLoading(false);
    }
  };

  const [formData, setFormData] = useState({
    name: "John Doe",
    email: "john.doe@example.com",
    phone: "+1234567890",
    location: "Brooklyn, NY",
    documents: [RegistrationImage, RegistrationImage], // Array of document images
  });

  const handleEditClick = () => {
    setIsEditing(!isEditing); // Toggle the editing mode
  };
  const handleEditVehicle = () => {
    setIsEditingVeh(!isEditingVeh); // Toggle the editing mode
  };
  
  const handleEditBank = () => {
    setIsEditingBank(!isEditingBank); // Toggle the editing mode
  };


  const filteredTables = data.filter((item) => {
    const available_status = item.available_status === 1 ? "Yes" : "No";
    const approval_status = item.approval_status === 1 ? "Verified"  : item.approval_status === 2 ? "Rejected" : "New";
    return (
      (item.name?.toLowerCase() || "") .includes(searchTerm.toLowerCase()) ||
      (item.mobile_no?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (item.email_id?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (item.current_location?.toLowerCase() || "").includes(searchTerm.toLowerCase()) || 
      (item.assigned_location?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      available_status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      approval_status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.secondary_mobile?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (item.blood_group?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (item.father_name?.toLowerCase() || "").includes(searchTerm.toLowerCase()) 
    );
  });
  
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
  const totalItems = filteredTables.length;
  
  const handleSearchInput = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page when search changes
  };
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getStatusDetails = (status) => {
    switch (status) {
      case 1:
        return { text: "Verified", color: "green" };
      case 2:
        return { text: "Rejected", color: "red" };
      default:
        return { text: "New", color: "blue" };
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setModalData({ ...modalData, [name]: value });
  };
  
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setModalData({ ...modalData, [name]: file });
  };
  
  //verify put method
  // const handleVerify = (id) => {
  //   const token = localStorage.getItem("Token"); // Replace with your token retrieval logic
  //   axios
  //     .put(
  //       `${var_api}delivery-person-management/approval-put/${id}`,
  //       { approval_status: 1, reject_remarks:"-" }, // Request payload
  //       {
  //         headers: {
  //           Authorization: `${token}`, // Pass token in Authorization header
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       Swal.fire({
  //         icon: 'success',
  //         text: 'Verified successfully',
  //         confirmButtonColor: '#007500',
  //       });
  //       fetchRole()
  //       // Optionally refresh the list or update state
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.status === 401) {
  //         localStorage.removeItem('Token'); // Clear the invalid token
  //         history.push('/')// Redirect to the Sign-In page
  //       } else {
  //         console.error("Error verifing data:", error);
  //       }
  //     });
  // };
  const handleVerify = (id, data) => {
    Swal.fire({
      title: 'Confirm Verification',
      html: `
        <div style="text-align: center;">
       <img 
        src="${data?.profile_image ? `${image_api}/${data.profile_image}` : `${profile}`}" 
        alt="Profile Image" 
        style="width: 100px; height: 100px; border-radius: 50%; margin-bottom: 10px;"
      />
      <p>Are you sure you want to verify this delivery person?</p>
        Name: <strong>${data?.name || 'N/A'}</strong><br>
       Assigned Address:  <strong>${data?.assigned_location || 'N/A'}</strong>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Verify',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#007500',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("Token");
        axios
          .put(
            `${var_api}delivery-person-management/approval-put/${id}`,
            { approval_status: 1, reject_remarks: "-" },
            {
              headers: {
                Authorization: `${token}`,
              },
            }
          )
          .then((response) => {
            Swal.fire({
              icon: 'success',
              text: 'Verified successfully',
              confirmButtonColor: '#007500',
            });
            fetchRole(); // Refresh the list or update state
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) {
              localStorage.removeItem('Token'); // Clear the invalid token
              history.push('/'); // Redirect to the Sign-In page
            } else {
              console.error("Error verifying data:", error);
            }
          });
      }
    });
  };
  
  const handleReject = () => {
    const token = localStorage.getItem("Token"); // Replace with your token retrieval logic
  
    if (!rejectremark) {
      alert("Remarks are required for rejection");
      return;
    }
  
    axios
      .put(
        `${var_api}delivery-person-management/approval-put/${dataID}`,
        { approval_status: 2, reject_remarks: rejectremark }, // Request payload
        {
          headers: {
            Authorization: ` ${token}`, // Pass token in Authorization header
          },
        }
      )
      .then((response) => {
        Swal.fire({
          icon: 'success',
          text: 'Rejected successfully',
          confirmButtonColor: '#007500',
        });
        showRemark(false);
        setRejectRemarks("");
        fetchRole();
        // Optionally refresh the list or update state
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error rejecting data:", error);
        }
      });
  };



  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
  
    // Append text fields
    Object.keys(modalData).forEach((key) => {
      if (modalData[key] && typeof modalData[key] !== "object") {
        formData.append(key, modalData[key]);
      }
    });
  
    // Append files (check if the file exists in state)
    if (modalData.id_proof_document instanceof File) {
      formData.append("id_proof_document", modalData.id_proof_document);
    }
    if (modalData.vehicle_doc1 instanceof File) {
      formData.append("vehicle_doc1", modalData.vehicle_doc1);
    }
    if (modalData.vehicle_doc2 instanceof File) {
      formData.append("vehicle_doc2", modalData.vehicle_doc2);
    }
    if (modalData.bank_doc1 instanceof File) {
      formData.append("bank_doc1", modalData.bank_doc1);
    }
    if (modalData.bank_doc2 instanceof File) {
      formData.append("bank_doc2", modalData.bank_doc2);
    }
  
    try {
      const token=localStorage.getItem('Token');
      const response = await axios.put(
        `${var_api}delivery-person-management/put/${modalData.id}`,
        formData,
     
        {
          headers: { "Content-Type": "multipart/form-data",
                     Authorization:`${token}`

           },

        }
      );
      fetchRole();
      setIsEditing(false);
      setModalData({});
      setIsEditingVeh(false);
      setIsEditingBank(false);
      setCreate(false);

       // Show success toast notification
    toast.success('Update successful!', {
      position: toast.POSITION.TOP_RIGHT,
    });
      console.log("Update Success:", response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error.response?.data);
      }
        // Show error popup using SweetAlert2
    Swal.fire({
      icon: 'error',
      title: 'Update Failed',
      text: error.response?.data?.message || 'An error occurred during the update process.',
    });
    }
  };


  const [showConfirm, setShowConfirm] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [changingKey, setChangingKey] = useState("");

  const handleActionClick = (type, key) => {
    setActionType(type);
    setChangingKey(key);
    if (type == 2) {
      setRemarks(""); // Clear remarks for rejection
    }
    setShowConfirm(true); // Show confirmation modal
  };

  const handleConfirm = () => {
    const token = localStorage.getItem("Token"); // Replace with your token retrieval logic
  
    if (!remarks && actionType == 2) {
      alert("Remarks are required for rejection");
      return;
    }

    const remarkKey =
    activeTab === "personalInformation" ?  "reject_remarks" : 
    activeTab === "vehicleDetails" ? "vehicle_detail_remark":
    activeTab === "personalDocuments" ? "personal_document_remark":
    activeTab === "bankDetails" ? "bank_detail_remark" : "remark"
    ;

  
    axios
      .put(
        `${var_api}delivery-person-management/status-put/${selectedPerson.details.id}`,
        {
          updated_Data: actionType == 1
            ? { [changingKey]: actionType } // Only send `changingKey` if actionType is 1
            : { [changingKey]: actionType, [remarkKey]: remarks || "-" },
        },
        {
          headers: {
            Authorization: ` ${token}`, // Pass token in Authorization header
          },
        }
      )
      .then((response) => {
        Swal.fire({
          icon: 'success',
          text: actionType === 1 ? 'Approved successfully' : 'Rejected successfully', // Change text based on actionType
          confirmButtonColor: '#007500',
        });
        // Update state to reflect the changes
      setSelectedPerson((prev) => ({
        ...prev,
        details: {
          ...prev.details,
          [activeTab]: {
            ...prev.details[activeTab],
            [changingKey]: actionType, // Update the approval status
            ...(actionType == 2 ? { [remarkKey]: remarks } : {}), // Add remarks if rejected
          }
        }
      }));
        setShowConfirm(false);
        setRemarks("");
        fetchRole();
        // Optionally refresh the list or update state
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error rejecting data:", error);
        }
      });
  };

  
  const renderDetails = () => {
    const currentPerson = selectedPerson.details;
  
    const currentDetails = currentPerson[activeTab];
    console.log("cur", currentDetails, currentPerson)

      // Center profile image and name
  const profileFields = {
    profile_image: currentDetails && currentDetails.profile_image,
    name: currentDetails && currentDetails.name,
  };

    const approvalKey =
      activeTab === "personalInformation" ?  "approval_status" : 
      activeTab === "vehicleDetails" ? "vehicle_detail_status":
      activeTab === "personalDocuments" ? "personal_document_status":
      activeTab === "bankDetails" ? "bank_detail_status" : "Approval Status"
      ;

      console.log("approvalKey", approvalKey, currentDetails[approvalKey], currentDetails);

    return (
      <div>
        {/* Approval Status */}
        <div style={{float:"right"}}>
          <strong>Approval Status: </strong>
          {currentDetails[approvalKey] == 0
            ? "New"
            : currentDetails[approvalKey] == 1
            ? <span style={{ color: "green", fontSize:"bold" }}>
           <i class="bi bi-check-circle-fill" style={{ marginRight: "5px" }}></i>
            Approved
          </span>
            :  currentDetails[approvalKey] == 2
            ?  <span style={{ color: "red", fontSize:"bold" }}>
            <i class="bi bi-x-circle-fill" style={{ marginRight: "5px" }}></i>
            Rejected
          </span>
             : "-"}
        </div>

       
        <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        {profileFields.profile_image && (
          <img
            src={`${image_api}/${profileFields.profile_image}`}
            alt="Profile"
            width="150"
            style={{
              borderRadius: "50%",
              marginBottom: "10px",
              border: "2px solid #ddd",
            }}
          />
        )}
        <h3>{profileFields.name || "N/A"}</h3>
      </div>

        {/* Render Details */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            marginTop: "20px",
          }}
        >
          {Object.entries(currentDetails)
          .filter(([key]) => key !== "name" && key !== "profile_image" && key !== "approval_status" && key !== "vehicle_detail_status" && key !== "personal_document_status" && key !== "bank_detail_status" && key !== "available_status")
          .map(([key, value]) => {
            // Define mappings for statuses
  const statusMappings = {
    approval_status: {
      0: { label: "New", color: "gray" },
      1: { label: "Approved", color: "green" },
      2: { label: "Rejected", color: "red" },
    },
    available_status: {
      0: { label: "Not Available", color: "gray" },
      1: { label: "Available", color: "blue" },
    },
  };

  // Check if the key matches any of the status fields
// Generate the display value
// Check if the key matches any of the status fields
const statusMapping = statusMappings[key];
const displayValue =
  statusMapping && value in statusMapping
    ? statusMapping[value].label // Extract the label for display
    : value || "N/A"; // Default to original value or "N/A" if no mapping found

      if (!displayValue) return null; // Skip empty fields

          // Check if the value is an image
          const isImage =
            typeof displayValue === "string" &&
            (displayValue.endsWith(".jpg") ||
            displayValue.endsWith(".png") ||
            displayValue.endsWith(".jpeg") ||
            displayValue.endsWith(".pdf"));

  return (

    <div
    key={key}
    style={{
      width: "calc(50% - 20px)",
      paddingBottom: "5px",
    }}
  >
    <p>
      <strong>{key.replace(/_/g, " ")}:</strong> 
      <div>
                {isImage ? (
                  <a
                  href={`${image_api}/${value}`} // Link to the image
                  target="_blank" // Open in new tab
                  rel="noopener noreferrer" // Security best practices
                >
                  <img
                    src={`${image_api}/${value}`}
                    alt={key}
                    style={{
                      width: "150px", // Fixed width
                  height: "150px", // Fixed height
                  objectFit: "cover", // Ensures the image fits within the size
                  borderRadius: "5px",
                  marginTop: "10px",
                    }}
                  />
                  </a>
                ) : (
                  <span  style={{
                    marginLeft: "5px",
                    color: statusMapping?.[value]?.color || "inherit",
                  }}>
                    {displayValue.toString().trim() || "N/A"}
                  </span>
                )}
              </div>
    </p>
  </div>
);
  })}
  <br/>

   {/* Action Buttons */}
   <div style={{ marginTop: "10px" }}>
          {currentDetails[approvalKey] == 0 && (
            <>
              <Button
                variant="success"
                onClick={() => handleActionClick(1, approvalKey)}
              >
                Approve
              </Button>
              <Button
                variant="danger"
                style={{ marginLeft: "10px" }}
                onClick={() => handleActionClick(2, approvalKey)}
              >
                Reject
              </Button>
            </>
          )}
          {currentDetails[approvalKey] == 2 && (
            <Button
              variant="success"
              onClick={() => handleActionClick(1, approvalKey)}
            >
              Approve
            </Button>
          )}
        </div>


        </div>

          {/* Confirmation Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {actionType === 1 ? "Confirm Approval" : "Confirm Rejection"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {actionType === 2 ? (
            <Form>
              <Form.Group controlId="remarks">
                <Form.Label>Rejection Remarks</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </Form.Group>
            </Form>
          ) : (
            <p>Are you sure you want to approve this?</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Close
          </Button>
          <Button  variant={actionType === 1 ? "success" : actionType === 2 ? "danger" : "primary"} onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    );
  };

 

  
  
  
    return(
      <>         <Layout>
      
            <div style={{border:"none", padding:"15px", width:"100%", height:"100%",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"-15px"}}>    
    
    <div>
  
   
     <div class="row">
       <div class="col">
       <h4 className='ushe'>DELIVERY PERSON MANAGEMENT</h4>
       </div>
       <div class="col">
       {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Supplier</Button>{' '} */}
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
     </div>
      <div className="table-container" style={{height:"550px", overflowX: 'scroll', overflowY: 'scroll'}}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"100%",margin:"auto"}}>
  <thead>
  <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Email</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Father_name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">secondary_mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">blood_group</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Location</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Available Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">View</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th> */}
    </tr>
  </thead>
  {loading ? (
        <Loader />
  ) : 
<tbody className="body-half-screen">
  {currentItems && currentItems.length > 0 ? (
    currentItems.map((data, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem+index+1}</td>
        <td>{data.name}</td>
        <td>{data.mobile_no}</td>
        <td>{data.email_id}</td>
        <td>{data.father_name}</td>
        <td>{data.secondary_mobile}</td>
        <td>{data.blood_group}</td>
        <td>{data.assigned_location}</td>
        <td style={{ color:data.available_status == 1 ? "green" : "red" }}>{data.available_status == 1 ? "Yes" : "No"}</td>
        {/* <td>
  {(() => {
    const { text, color } = getStatusDetails(data.approval_status);
    return <h6 style={{ color }}>{text}</h6>;
  })()}
</td> */}


        <td >
        <Button variant="primary" size='sm' onClick={()=>openModalEye(data)}><i class="bi bi-eye"></i></Button>
        </td>
        {/* <td>
  <div style={{ display: 'flex', gap: '5px' }}>
    {(data.approval_status == 0 || data.approval_status == null) && (
      <>
        <Button variant="success" size="sm" onClick={() => handleVerify(data.id, data)}>
          VERIFY
        </Button>
        <Button variant="danger" size="sm" onClick={() => openRemark(data.id)}>
          REJECT
        </Button>
      </>
    )}
    {data.approval_status == 1 && (
      <Button variant="danger" size="sm" onClick={() => openRemark(data.id)}>
        REJECT
      </Button>
    )}
    {data.approval_status == 2 && (
      <Button variant="success" size="sm" onClick={() => handleVerify(data.id, data)}>
        VERIFY
      </Button>
    )}
  </div>
</td> */}

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="14" style={{ textAlign: "center", color: "red", fontWeight: "bold", borderColor: "black" }}>
        No Data Available
      </td>
    </tr>
  )}
</tbody>

}
</table>
<br/>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      {/* </div> */}

     

    
      <Modal
        show={showrePop}
        onHide={()=>showRemark(false)}
        backdrop="static"
        keyboard={false}
        size="m"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> Remarks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <lable className="form-lable">Remarks</lable>
            <input type="text" class="form-control" placeholder="Enter Remarks" id="input1"   name="e_name"  value={rejectremark}
      onChange={(e) => setRejectRemarks(e.target.value)}
      required/>
            <button className="btn btn-danger" style={{float:"right",margin:"5px",borderRadius:"15px"}} onClick={handleReject}>REJECT</button>

            </Modal.Body>
            </Modal>


            <Modal
      show={isCreate}
      onHide={() => setCreate(false)}
      backdrop="static"
      keyboard={false}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>VIEW DETAILS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: "flex" }}>
          {/* Left Side Buttons */}
          <div
            style={{
              width: "25%",
              borderRight: "1px solid #ddd",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Button
              variant={activeTab === "personalInformation" ? "primary" : "light"}
              onClick={() => setActiveTab("personalInformation")}
            >
              Personal Information
            </Button>
            <Button
              variant={activeTab === "personalDocuments" ? "primary" : "light"}
              onClick={() => setActiveTab("personalDocuments")}
            >
              Personal Documents
            </Button>
            <Button
              variant={activeTab === "vehicleDetails" ? "primary" : "light"}
              onClick={() => setActiveTab("vehicleDetails")}
            >
              Vehicle Details
            </Button>
            <Button
              variant={activeTab === "bankDetails" ? "primary" : "light"}
              onClick={() => setActiveTab("bankDetails")}
            >
              Bank Details
            </Button>
          </div>

          {/* Right Side Details */}
          <div
            style={{
              width: "75%",
              padding: "20px",
            }}
          >
            {selectedPerson && renderDetails()}
          </div>
        </div>
      </Modal.Body>
    </Modal>





      {/* <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> VEHICLE DETAILS</Modal.Title>
        </Modal.Header>
     <Modal.Body>
  <form onSubmit={handleSubmit}>
    <div className="info-card">
      <div className="section" style={{borderTop:"none"}}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>Personal Info</h3> <Button variant='warning'  onClick={handleEditClick}><i className="bi bi-pencil-square"></i></Button>
        </div>
        <div className="details-grid">
        <div className="detail-item">
          <label className="form-label" htmlFor="name">Name:</label>
          <input 
            id="name" 
            type="text" 
            className="form-control" 
            value={modalData.name} 
            disabled={!isEditing} 
            onChange={(e) => setModalData({ ...modalData, name: e.target.value })}
          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="email_id">Email ID:</label>
          <input 
            id="email_id" 
            type="email" 
            className="form-control" 
            value={modalData.email_id} 
            disabled={!isEditing} 
            onChange={(e) => setModalData({ ...modalData, email_id: e.target.value })}
          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="mobile_no">Ph.No.:</label>
          <input 
            id="mobile_no" 
            type="tel" 
            className="form-control" 
            value={modalData.mobile_no} 
            disabled={!isEditing} 
            onChange={(e) => setModalData({ ...modalData, mobile_no: e.target.value })}
          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="current_location">Location:</label>
          <input 
            id="current_location" 
            type="text" 
            className="form-control" 
            value={modalData.current_location} 
            disabled={!isEditing} 
            onChange={(e) => setModalData({ ...modalData, current_location: e.target.value })}
          />
        </div>
        {!isEditing && (    <div className="detail-item">
            <label className="form-label" htmlFor="documents">Documents:</label>
          

            <div className="document-display"        >
              <img
                            src={modalData.id_proof_document ? `${image_api}/${modalData.id_proof_document}` : DefaultProfileImage}
                          
                            alt="Registration Document"
                          />
            </div> */}

            {/* <div className="document-display">
              <img src={RegistrationImage} alt="Registration Document" />

            </div> */}
   
        
          {/* </div>
        )}

{isEditing && (    <div className="detail-item">
            <label className="form-label" htmlFor="documents">Documents:</label>
          
      <input type='file' className='form-control'   onChange={(e) => {
    const file = e.target.files[0]; // Get the first selected file
    setModalData({ ...modalData, id_proof_document: file }); // Update the state with the file
  }}/>
   
        
          </div>
        )}
        </div>
      </div>

      // Vehicle Details Section 
      <div className="section">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3>Vehicle Details</h3>  
        <Button variant="warning" onClick={handleEditVehicle}>
          <i className="bi bi-pencil-square"></i> 
        </Button>
      </div>
      <div className="details-grid">
        <div className="detail-item">
          <label className="form-label" htmlFor="vehicle_id">Vehicle ID:</label>
          <input 
            id="vehicle_id" 
            type="text" 
            className="form-control" 
            value={modalData.vehicle_id} 
            disabled={!isEditingVeh} 
            onChange={(e) => setModalData({ ...modalData, vehicle_id: e.target.value })}

          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="vehicle_type">Type:</label>
          <input 
            id="vehicle_type" 
            type="text" 
            className="form-control" 
            value={modalData.vehicle_type} 
            disabled={!isEditingVeh} 
            onChange={(e) => setModalData({ ...modalData, vehicle_type: e.target.value })}

          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="capacity">Capacity:</label>
          <input 
            id="capacity" 
            type="text" 
            className="form-control" 
            value={modalData.capacity} 
            disabled={!isEditingVeh} 
            onChange={(e) => setModalData({ ...modalData, capacity: e.target.value })}

          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="vehicle_model">Model:</label>
          <input 
            id="vehicle_model" 
            type="text" 
            className="form-control" 
            value={modalData.vehicle_model} 
            disabled={!isEditingVeh} 
            onChange={(e) => setModalData({ ...modalData, vehicle_model: e.target.value })}

          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="vehicle_year">Year:</label>
          <input 
            id="vehicle_year" 
            type="text" 
            className="form-control" 
            value={modalData.vehicle_year} 
            disabled={!isEditingVeh} 
            onChange={(e) => setModalData({ ...modalData, vehicle_year: e.target.value })}

          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="registration_no">Registration No:</label>
          <input 
            id="registration_no" 
            type="text" 
            className="form-control" 
            value={modalData.registration_no} 
            disabled={!isEditingVeh} 
            onChange={(e) => setModalData({ ...modalData, registration_no: e.target.value })}

          />
        </div>
        <div className="detail-item">
          <label className="form-label" htmlFor="name">Driver Name:</label>
          <input 
            id="name" 
            type="text" 
            className="form-control" 
            value={modalData.name} 
            disabled={!isEditingVeh} 
            onChange={(e) => setModalData({ ...modalData, name: e.target.value })}

          />
        </div>
        <div className="detail-item" style={{display:"flex",flexDirection:"column",alignItems:"start"}}>
        <label className="form-label" htmlFor="vehicle_status">Vehicle Status: <span style={{ color: modalData.vehicle_status == 1 ? "green" : "red"}}>{modalData.vehicle_status == 1 ? "Active" : "Inactive" }</span></label>
         */}
          {/* <input 
            id="vehicleStatus" 
            type="text" 
            className="form-control" 
            value={modalData.vehicleStatus} 
            disabled={!isEditingVeh} 
          /> */}
          {/* <br></br> */}
           {/* <div className="form-check form-switch">
                            <input
              className="form-check-input m-0"
              type="checkbox"
              role="switch"
              disabled={!isEditingVeh} 
              checked={modalData.vehicle_status === 1} // Checkbox is checked if is_active is 1
              onChange={(e) =>
                setModalData({ ...modalData, vehicle_status: e.target.checked ? 1 : 0 })
              }            />
        </div> */}
          
        {/* </div>

        Documents Section
        {isEditingVeh ? (
            <div className="detail-item">
            <label className="form-label" htmlFor="documents">Document 1:</label>
            <input type="file" className="form-control"  onChange={(e) => {
    const file = e.target.files[0]; // Get the first selected file
    setModalData({ ...modalData, vehicle_doc1: file }); // Update the state with the file
  }}/>
          </div>
        
        ) : (
          <div className="detail-item">
            <label className="form-label" htmlFor="documents">Document 1:</label>
            <div className="document-display">
              <img  src={modalData.vehicle_doc1 ? `${image_api}/${modalData.vehicle_doc1}` : DefaultProfileImage}  alt="Registration Document"/>
            </div>
          
          </div>
        )}
        {isEditingVeh ? (
            <div className="detail-item">
            <label className="form-label" htmlFor="documents">Documents 2:</label>
            <input type="file" className="form-control"   onChange={(e) => {
    const file = e.target.files[0]; // Get the first selected file
    setModalData({ ...modalData, vehicle_doc2: file }); // Update the state with the file
  }}/>
          </div>
        
        ) : (
          <div className="detail-item">
            <label className="form-label" htmlFor="documents">Document 2:</label>
          
            <div className="document-display">
             
              <img src={modalData.vehicle_doc2 ? `${image_api}/${modalData.vehicle_doc2}` : DefaultProfileImage} alt="Registration Document"/>
            </div>
          </div>
        )}
      </div>
    </div>
     
      <div className="section">
      <div style={{ display: "flex", justifyContent: "space-between" }}>

        <h3>Bank Details</h3> <Button variant='warning' onClick={handleEditBank}><i className="bi bi-pencil-square"></i></Button>
</div>
        <div className="details-grid">
          <div className="detail-item">
            <label className="form-label" htmlFor="bank_name">Bank Name:</label>
            <input id="bank_name" type="text"className="form-control" value={modalData.bank_name}              onChange={(e) => setModalData({ ...modalData, bank_name: e.target.value })}
  disabled={!isEditingBank}  />
          </div>
          <div className="detail-item">
            <label className="form-label" htmlFor="account_number">Account Number:</label>
            <input id="account_number"             onChange={(e) => setModalData({ ...modalData, account_number: e.target.value })}
 type="number" value={modalData.account_number} className="form-control" disabled={!isEditingBank} min="1"/>
          </div>
              
        {isEditingBank ? (
            <div className="detail-item">
            <label className="form-label" htmlFor="documents">Document 1:</label>
            <input type="file" className="form-control"   onChange={(e) => {
    const file = e.target.files[0]; // Get the first selected file
    setModalData({ ...modalData, bank_doc1: file }); // Update the state with the file
  }}/>
          </div>
        
        ) : (
          <div className="detail-item">
            <label className="form-label" htmlFor="documents">Document 1:</label>
            <div className="document-display">
            
              <img src={modalData.bank_doc1 ? `${image_api}/${modalData.bank_doc1}` : DefaultProfileImage} alt="Registration Document"/>

            </div>
            
          </div>
        )}
         {isEditingBank ? (
            <div className="detail-item">
            <label className="form-label" htmlFor="documents">Document 2:</label>
            <input type="file" className="form-control"   onChange={(e) => {
    const file = e.target.files[0]; // Get the first selected file
    setModalData({ ...modalData, bank_doc2: file }); // Update the state with the file
  }}/>
          </div>
        
        ) : (
          <div className="detail-item">
            <label className="form-label" htmlFor="documents">Document 2:</label>
           
            <div className="document-display">
           
              <img src={modalData.bank_doc2 ? `${image_api}/${modalData.bank_doc2}` : DefaultProfileImage} alt="Registration Document"/>

            </div>
          </div>
        )}
        </div>

      </div>

      <button className='btn btn-success' type="submit" style={{borderRadius:"15px",float:"right",margin:"6px"}} disabled={postloading}>Update</button>
      <button className='btn btn-danger' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Cancel</button>
    
      {showModal && (
        <div className="modals" onClick={closeModal}>
          <div className="modals-content" onClick={(e) => e.stopPropagation()}>
            <img src={RegistrationImage} alt="Full Registration Document" />
            <button className="close" onClick={closeModal}>  <i className="bi bi-x"></i></button>
          </div>
        </div>
      )}
    </div>
  </form>
</Modal.Body>


      </Modal>  */}

  


            {/* </div> */}
       </Layout></>

        
    )
}

export default AdminSupplierMaster;